import courseSearchEN from "./locales/en/course-search.json";
import courseSearchPS from "./locales/ps/course-search.json";
import courseSearchPR from "./locales/pr/course-search.json";
import profileDashboardEN from "./locales/en/profile-dashboard.json";
import profileDashboardPS from "./locales/ps/profile-dashboard.json";
import profileDashboardPR from "./locales/pr/profile-dashboard.json";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

export const DEFAULT_LANGUAGE = "ps";
export const RTL_LANGUAGES = ["ps", "pr", "fa", "ar", "ur"];

export const getLanguageDirection = (language) => {
  const normalizedLanguage = (language || i18n.resolvedLanguage || i18n.language || DEFAULT_LANGUAGE)
    .toLowerCase()
    .split("-")[0];

  return RTL_LANGUAGES.includes(normalizedLanguage) ? "rtl" : "ltr";
};

export const applyDocumentLanguage = (language) => {
  if (typeof document === "undefined") {
    return;
  }

  const resolvedLanguage = language || i18n.resolvedLanguage || i18n.language || DEFAULT_LANGUAGE;
  const direction = getLanguageDirection(resolvedLanguage);
  const html = document.documentElement;

  html.setAttribute("lang", resolvedLanguage);
  html.setAttribute("dir", direction);

  if (document.body) {
    document.body.style.fontFamily =
      direction === "rtl" ? "'BahijHelveticaNeue', sans-serif" : "'Satoshi', sans-serif";
  }
};

i18n.use(initReactI18next).init({
  fallbackLng: localStorage.getItem("lang") || DEFAULT_LANGUAGE,
  lng: localStorage.getItem("lang") || DEFAULT_LANGUAGE,
  resources: {
    en: {
      translations: {
        ...require("./locales/en/translations.json"),
        ...require("./locales/en/teacher-studio.json"),
        ...profileDashboardEN,
      }
    },
    ps: {
      translations: {
        ...require("./locales/ps/translations.json"),
        ...require("./locales/ps/teacher-studio.json"),
        ...profileDashboardPS,
      }
    },
    pr: {
      translations: {
        ...require("./locales/pr/translations.json"),
        ...require("./locales/pr/teacher-studio.json"),
        ...profileDashboardPR,
      }
    }
  },
  ns: ["translations"],              // Default namespace
  defaultNS: "translations",         // Default namespace
  interpolation: {
    escapeValue: false               // Not needed for React
  }
});

i18n.addResources("en", "translations", {
  "Liked-Courses": "Liked courses",
  "No-liked-courses": "You have not liked any courses yet.",
  "ReviewForm.DeleteTitle": "Delete this review?",
  "ReviewForm.DeleteDescription": "This will permanently remove your review from the course.",
  "ReviewForm.DeleteAction": "Delete review",
  "validation.review_duplicate": "You already submitted the same review for this course.",
  "toast.review-delete-success": "Review deleted successfully!",
  "toast.review-delete-failed": "Failed to delete the review. Please try again later.",
  "Current-lesson": "Current lesson",
  "Preparing-download": "Preparing...",
  "Preparing-download-message": "Preparing download for this lesson",
  "Download-ready": "Download ready",
  "Download-unavailable": "Download unavailable",
  "Retry-download": "Retry download",
  "Download-video-file": "Download lesson video",
  "Download-started": "Your download has started.",
  "Download-failed": "Download failed. Please try again.",
  "Downloading": "Downloading...",
});

i18n.addResources("pr", "translations", {
  "Liked-Courses": "کورس‌های پسندیده‌شده",
  "No-liked-courses": "شما هنوز هیچ کورسی را نپسندیده‌اید.",
  "ReviewForm.DeleteTitle": "حذف این نظر؟",
  "ReviewForm.DeleteDescription": "این کار نظر شما را به صورت دایمی از این کورس حذف می‌کند.",
  "ReviewForm.DeleteAction": "حذف نظر",
  "validation.review_duplicate": "شما همین نظر را قبلاً برای این کورس ثبت کرده‌اید.",
  "toast.review-delete-success": "نظر با موفقیت حذف شد!",
  "toast.review-delete-failed": "حذف نظر ناکام شد. لطفاً دوباره تلاش کنید.",
});

i18n.addResources("ps", "translations", {
  "Liked-Courses": "خوښ شوي کورسونه",
  "No-liked-courses": "تاسو تراوسه کوم کورس نه دی خوښ کړی.",
  "ReviewForm.DeleteTitle": "دا بیاکتنه حذف شي؟",
  "ReviewForm.DeleteDescription": "دا کار به ستاسو بیاکتنه له دې کورس څخه د تل لپاره حذف کړي.",
  "ReviewForm.DeleteAction": "بیاکتنه حذف کړئ",
  "validation.review_duplicate": "تاسو همدا بیاکتنه مخکې د دې کورس لپاره ثبت کړې ده.",
  "toast.review-delete-success": "بیاکتنه په بریالیتوب سره حذف شوه!",
  "toast.review-delete-failed": "د بیاکتنې حذف ناکام شو. مهرباني وکړئ بیا هڅه وکړئ.",
});

i18n.addResources("ps", "translations", {
  "Edit-your-review": "سمون",
  "Delete": "ړنګول",
  "Deleting": "د ړنګولو په حال کې...",
  "ReviewForm.DeleteTitle": "دا بیاکتنه ړنګه شي؟",
  "ReviewForm.DeleteDescription": "دا کار به ستاسو بیاکتنه له دې کورس څخه د تل لپاره ړنګه کړي.",
  "ReviewForm.DeleteAction": "بیاکتنه ړنګه کړئ",
  "toast.review-delete-success": "بیاکتنه په بریالیتوب سره ړنګه شوه!",
  "toast.review-delete-failed": "د بیاکتنې ړنګول ناکام شول. مهرباني وکړئ بیا هڅه وکړئ.",
});

i18n.addResources("pr", "translations", {
  "chapters": "ویدیوګانی",
  "videos": "ویدیوګانی",
});

i18n.addResources("pr", "translations", {
  "Current-lesson": "\u062f\u0631\u0633 \u0641\u0639\u0644\u06cc",
  "Preparing-download": "\u062f\u0631 \u062d\u0627\u0644 \u0622\u0645\u0627\u062f\u0647\u200c\u0633\u0627\u0632\u06cc...",
  "Preparing-download-message": "\u062f\u0627\u0646\u0644\u0648\u062f \u0627\u06cc\u0646 \u062f\u0631\u0633 \u062f\u0631 \u062d\u0627\u0644 \u0622\u0645\u0627\u062f\u0647\u200c\u0633\u0627\u0632\u06cc \u0627\u0633\u062a",
  "Download-ready": "\u062f\u0627\u0646\u0644\u0648\u062f \u0622\u0645\u0627\u062f\u0647 \u0627\u0633\u062a",
  "Download-unavailable": "\u062f\u0627\u0646\u0644\u0648\u062f \u062f\u0631 \u062f\u0633\u062a\u0631\u0633 \u0646\u06cc\u0633\u062a",
  "Retry-download": "\u062a\u0644\u0627\u0634 \u062f\u0648\u0628\u0627\u0631\u0647 \u0628\u0631\u0627\u06cc \u062f\u0627\u0646\u0644\u0648\u062f",
  "Download-video-file": "\u062f\u0627\u0646\u0644\u0648\u062f \u0648\u06cc\u062f\u06cc\u0648\u06cc \u062f\u0631\u0633",
  "Download-started": "\u062f\u0627\u0646\u0644\u0648\u062f \u0634\u0645\u0627 \u0634\u0631\u0648\u0639 \u0634\u062f.",
  "Download-failed": "\u062f\u0627\u0646\u0644\u0648\u062f \u0646\u0627\u06a9\u0627\u0645 \u0634\u062f. \u0644\u0637\u0641\u0627\u064b \u062f\u0648\u0628\u0627\u0631\u0647 \u062a\u0644\u0627\u0634 \u06a9\u0646\u06cc\u062f.",
  "Downloading": "\u062f\u0631 \u062d\u0627\u0644 \u062f\u0627\u0646\u0644\u0648\u062f...",
});

i18n.addResources("ps", "translations", {
  "Current-lesson": "\u0627\u0648\u0633\u0646\u06cd \u0648\u06cc\u0689\u06cc\u0648",
  "Preparing-download": "\u062f \u0689\u0627\u0648\u0646\u0644\u0648\u0689 \u0686\u0645\u062a\u0648 \u06a9\u06cc\u0696\u064a...",
  "Preparing-download-message": "\u062f \u062f\u06d0 \u0648\u06cc\u0689\u06cc\u0648 \u0689\u0627\u0648\u0646\u0644\u0648\u0689 \u0686\u0645\u062a\u0648 \u06a9\u06cc\u0696\u064a",
  "Download-ready": "\u0689\u0627\u0648\u0646\u0644\u0648\u0689 \u0686\u0645\u062a\u0648 \u062f\u06cc",
  "Download-unavailable": "\u0689\u0627\u0648\u0646\u0644\u0648\u0689 \u0646\u0647 \u0634\u0648 \u062a\u0631\u0633\u0647 \u06a9\u06cc\u062f\u0644\u06cc",
  "Retry-download": "\u0689\u0627\u0648\u0646\u0644\u0648\u0689 \u0628\u06cc\u0627 \u0648\u0627\u0632\u0645\u0648\u06cc\u06cc",
  "Download-video-file": "\u062f \u062f\u0631\u0633 \u0648\u06cc\u0689\u06cc\u0648 \u0689\u0627\u0648\u0646\u0644\u0648\u0689",
  "Download-started": "\u0633\u062a\u0627\u0633\u0648 \u0689\u0627\u0648\u0646\u0644\u0648\u0689 \u067e\u06cc\u0644 \u0634\u0648.",
  "Download-failed": "\u0689\u0627\u0648\u0646\u0644\u0648\u0689 \u0646\u0627\u06a9\u0627\u0645 \u0634\u0648. \u0645\u0647\u0631\u0628\u0627\u0646\u064a \u0648\u06a9\u0693\u0626 \u0628\u06cc\u0627 \u06cc\u06d0 \u0647\u0685\u0647 \u0648\u06a9\u0693\u0626.",
  "Downloading": "\u062f \u0689\u0627\u0648\u0646\u0644\u0648\u0689 \u067e\u0647 \u062d\u0627\u0644 \u06a9\u06d0...",
});

i18n.languages = ["en", "ps", "pr"];  // Supported languages
i18n.dir = (language) => getLanguageDirection(language);
i18n.on("languageChanged", (language) => applyDocumentLanguage(language));

i18n.addResourceBundle("en", "translations", { courseSearch: courseSearchEN }, true, true);
i18n.addResourceBundle("ps", "translations", { courseSearch: courseSearchPS }, true, true);
i18n.addResourceBundle("pr", "translations", { courseSearch: courseSearchPR }, true, true);

export default i18n;
